import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import HolidayYearTableRow from './HolidayYearTableRow';
import { holidayDatesType } from '../../types';
import './_styles_/HolidayYearTable.css';
import { idSortFunc } from '../../utils/tableRecords';

HolidayYearTable.propTypes = {
    year: PropTypes.number,
    holidays: holidayDatesType.isRequired,
    onHolidayYearDateDelete: PropTypes.func.isRequired,
    onHolidayYearDateChange: PropTypes.func.isRequired,
    doReset: PropTypes.bool.isRequired,
    doResetComponentsAfterModification: PropTypes.bool.isRequired,
};

HolidayYearTable.defaultProps = {
    year: null,
};

function HolidayYearTable(props) {
    const {
        year,
        holidays,
        onHolidayYearDateDelete,
        onHolidayYearDateChange,
        doReset,
        doResetComponentsAfterModification,
    } = props;
    const { t } = useTranslation();
    const sortedHolidays = [...holidays].sort(idSortFunc);
    return (
        <div className="detail-list holiday-year-table">
            <div className="detail-list-row detail-list-header">
                <div className="holiday-year-cell--small">&nbsp;</div>
                <div className="holiday-year-cell holiday-year-table-row--header--name">{t('holidays.holiday.name')}</div>
                <div className="holiday-year-cell holiday-year-table-row--header--date">{t('holidays.holiday.date')}</div>
            </div>
            {sortedHolidays.map((holiday) => (
                <HolidayYearTableRow
                    key={holiday.id}
                    year={year}
                    holiday={holiday}
                    holidays={sortedHolidays}
                    onHolidayYearDateDelete={onHolidayYearDateDelete}
                    onHolidayYearDateChange={onHolidayYearDateChange}
                    doReset={doReset}
                    doResetComponentsAfterModification={doResetComponentsAfterModification}
                />
            ))}
        </div>
    );
}

export default HolidayYearTable;
